<template>
  <div class="item-wrapper">
    <AmexBtn
      :class="{'drop-item': true, selected: isSelected, [variant]: true}"
      :style="cssStyles"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <div class="loading-item" :class="{active: isLoading}">
        <div class="loading-value"></div>
        <div class="loading-label"></div>
      </div>

      <div class="value" :class="{none: isNone, hasIcon: iconCssVarName}">{{ value }}</div>
      <div class="label" :class="{none: isNone}">{{ displayLabel }}</div>
    </AmexBtn>
  </div>
</template>

<script>
import Vue from 'vue';
import AmexBtn from '@common/button/base-button.vue';

export default Vue.extend({
  components: {
    AmexBtn,
  },
  name: 'DropdownItem',
  props: {
    label: {
      default: '',
      type: String,
    },
    isSelected: Boolean,
    value: String,
    iconCssVarName: String,
    isLoading: Boolean,
    variant: String,
  },
  computed: {
    isNone() {
      return this.label === 'NONE';
    },
    displayLabel() {
      return this.isNone ? 'We couldn’t find any destinations!' : this.label;
    },
    cssStyles() {
      return this.iconCssVarName
        ? {
            'background-image': `var(${this.iconCssVarName})`,
          }
        : {};
    },
  },
});
</script>

<style scoped>
.loading-item {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #fff;
  opacity: 0;
}

.loading-item.active {
  opacity: 1;
}

.loading-label {
  top: 15px;
  left: 13px;
  position: absolute;
  width: 10%;
  min-width: 24px;
  height: 10px;
  background: #f1f1f1;
  border-radius: 10px;
}

.loading-value {
  top: 29px;
  left: 13px;
  position: absolute;
  width: 80%;
  height: 17px;
  background: #f1f1f1;
  border-radius: 10px;
}

.item-wrapper {
  width: 100%;
  box-sizing: border-box;
  border-bottom: solid 1px var(--select-divider, #f1f1f1);
  padding: 4px 5px;
}

.drop-item {
  display: inline-block;
  position: relative;
  width: 100%;
  color: var(--font-color-light, #556b90);
  padding: 5px 5px;
  background-color: #fff;
  line-height: 1.2em;
  text-align: left;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 6px;
  background-repeat: no-repeat;
  background-position: 7px 8px;
  background-size: 12px auto;
}

.drop-item * {
  box-sizing: border-box;
}

.drop-item:hover {
  background-color: #f1f1f1;
}

.drop-item .label {
  color: var(--filter-label-color, #f1f1f1);
  font-size: 12px;
  text-transform: capitalize;
  padding-left: 26px;
}

.drop-item .value {
  font-size: 18px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: var(--drop-item-line-height, 1);
  padding: 3px 0 0 26px;
}

.drop-item.small {
  padding: 3px 5px;
}

.drop-item.small .value {
  font-size: 14px;
  color: var(--font-color-darker, #000);
}

.drop-item .value.none {
  opacity: 0;
}

.drop-item .label.none {
  white-space: nowrap;
  padding: 20px 20px 10px;
}

.drop-item:not(:last-of-type) {
  border-top: none;
  border-bottom: 1px solid var(--select-divider, #f1f1f1);
}

.drop-item.selected {
  font-weight: 700;
  color: var(--font-color-dark, #071d3b);
}

.drop-item.selected::before {
  content: '';
  position: absolute;
  top: 17px;
  left: 6px;
  margin: -8px -8px 0 0;
  opacity: 1;
  transform: none;
  width: 13px;
  height: 13px;
  border-radius: 14px;
  background-color: var(--primary-color, #2c70c9);
  background-image: url("data:image/svg+xml,%3Csvg width='6' height='5' viewBox='0 0 6 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.3215 0.617066C5.53299 0.794617 5.56051 1.11 5.38296 1.3215L2.86444 4.3215C2.76944 4.43466 2.62925 4.50001 2.48149 4.50001C2.33374 4.50001 2.19355 4.43466 2.09855 4.3215L0.617066 2.55679C0.439515 2.3453 0.467031 2.02991 0.678526 1.85236C0.890021 1.67481 1.20541 1.70233 1.38296 1.91382L2.48149 3.22237L4.61707 0.678526C4.79462 0.467031 5.11 0.439515 5.3215 0.617066Z' fill='white'/%3E%3C/svg%3E%0A");
  background-size: 7px;
  background-position: 3px 4px;
  background-repeat: no-repeat;
}
</style>
